// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__f0m9H"};